import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { NotificationContainer } from 'react-notifications';
import ForgotPassword from './views/Auth/ForgotPassword';
import ResetPassword from './views/Auth/ResetPassword';
import Login from './views/Auth/Login';
import Layout from './components/Layout';
import { ProfileContextProvider } from './store/context/ProfileContext';
import { CmsContextProvider } from './store/context/CmsContext';
import { privateRouteList } from './routes/routeLists';
import Dashboard from './views/dashboard';
import slugs from './resources/slugs';

const App = () => {
  const isUserLoggedIn =
    localStorage.getItem("token") &&
    localStorage.getItem("token") !== "undefined";
    
  return (
    <>
      <NotificationContainer />
      <Router>
        <CmsContextProvider>
          {!isUserLoggedIn ? (
            <Routes>
              <Route exact path="/" element={<Login />} />
              <Route exact path="/login" element={<Login />} />
              <Route exact path="/forgot_password" element={<ForgotPassword />} />
              <Route exact path="/reset_password" element={<ResetPassword />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          ) : (
            <ProfileContextProvider>
              <Layout>
                <Routes>
                  {privateRouteList.map((route) => (
                    <Route
                      key={route.id}
                      path={route.path}
                      element={route.component}
                    />
                  ))}
                  <Route path="*" element={<Dashboard />} />
                </Routes>
              </Layout>
            </ProfileContextProvider>
          )}
        </CmsContextProvider>
      </Router>
    </>
  );
};

export default App;
